import React from 'react';
import { Link } from 'react-router-dom';

const Terms: React.FC = () => {
  return (
    <div className="sw-container" style={{ padding: 'var(--sp-12) var(--sp-3)' }}>
        <Link to="/" style={{ display: 'inline-flex', marginBottom: 'var(--sp-6)', color: 'var(--primary-light)', fontWeight: 700 }}>
            ← Back to Home
        </Link>
        <div className="sw-glass" style={{ padding: 'var(--sp-10)', maxWidth: '900px', margin: '0 auto', color: 'var(--text-soft)' }}>
            <h1 style={{ marginBottom: 'var(--sp-2)', color: 'var(--text)' }}>Terms of Service</h1>
            <span style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: 'var(--sp-8)', display: 'block' }}>
                Last Updated: August 17, 2026
            </span>

            <section style={{ marginBottom: 'var(--sp-8)' }}>
                <p>Welcome to Swiftech. By accessing our website and using our digital services, you agree to comply with and be bound by the following terms and conditions.</p>
            </section>

            <section style={{ marginBottom: 'var(--sp-8)' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--primary-light)', borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>1. Services</h2>
                <p>Swiftech provides web development, digital solutions, and website template services. All services are subject to specific project agreements and proposals provided to the client.</p>
            </section>

            <section style={{ marginBottom: 'var(--sp-8)' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--primary-light)', borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>2. Intellectual Property</h2>
                <p>Unless otherwise stated, Swiftech owns the intellectual property rights for all material on the website (excluding client-specific content). You may view this for your own personal use subject to restrictions set in these terms.</p>
                <ul style={{ marginLeft: 'var(--sp-4)', listStyle: 'disc', marginBottom: 'var(--sp-4)' }}>
                    <li>You must not republish material from Swiftech.</li>
                    <li>You must not sell, rent, or sub-license material from Swiftech.</li>
                    <li>You must not reproduce or duplicate material from Swiftech.</li>
                </ul>
            </section>

            <section style={{ marginBottom: 'var(--sp-8)' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--primary-light)', borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>3. User Responsibilities</h2>
                <p>Users are responsible for ensuring that all information provided through contact forms is accurate and does not violate any third-party rights.</p>
            </section>

            <section style={{ background: 'rgba(245, 158, 11, 0.05)', padding: 'var(--sp-6)', borderRadius: 'var(--radius-md)', border: '1px solid rgba(245, 158, 11, 0.2)', marginBottom: 'var(--sp-8)' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--warning)' }}>4. Limitation of Liability</h2>
                <p>Swiftech will not be held liable for any damages arising out of or in connection with the use of our website or services, to the maximum extent permitted by applicable law.</p>
            </section>

            <section>
                <h2 style={{ fontSize: '1.5rem', marginBottom: 'var(--sp-4)', color: 'var(--primary-light)', borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>5. Governing Law</h2>
                <p>These terms are governed by and construed in accordance with the laws of Lebanon, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
            </section>
        </div>
    </div>
  );
};

export default Terms;
